import { createContext, useContext } from "react";
import type { CustomerDetails } from "../types/customerDetailsTypes";

/**
 * Customer profile loaded once by AppWrapper (name, branch, BDE, sales rep...).
 * Provided around the routed pages so any page can greet the user or show
 * their account team without refetching. `null` until the profile has loaded.
 */
export const UserContext = createContext<CustomerDetails | null>(null);

export const useUserData = () => useContext(UserContext);
